import h from "../core/createElement";
import { byteMetter } from "../utils";

export default function SimpleFileCard({ data: { name, size, type, id }, onClick }) {

    const _size = byteMetter(size), _types = { sub_report: "Sub Relatório", main_report: "Principal" };

    return (
        <article class="card hover" onClick={() => onClick && onClick({ name, size, type, id })}>
            <div class="top">
                <span class="title">{name}</span>
                <span>{_size.total.toFixed(2) + _size.unity}</span>
            </div>

            <div class="bottom">
                <div class="flex-1">
                    <span class="orange">{_types[type]}</span>
                </div>
            </div>
        </article>
    );
};